import { Component, OnInit } from '@angular/core';
import { ParEmployeeService } from '../../services/par_employees/par_employees.service';
import { debug } from 'util';

@Component({
  selector: 'app-paremployee-summary-tab',
  templateUrl: './paremployee-summary-tab.component.html',
  styleUrls: ['./paremployee-summary-tab.component.css']
})
export class ParemployeeSummaryTabComponent implements OnInit {
  DocListErrMsg;
  DocListErr: boolean = false;
  clientDisable: any;
  clientHidden: any;
  public role: string;
  public employeeId: any;
  public fxDisplay: any = 100;
  empID: any;
  emp_id: any;
  getAllPAREmployeeDataById: any = [];
  constructor(private parEmployeeService: ParEmployeeService) { }

  ngOnInit() {
    this.employeeId = localStorage.getItem("dbId");
    this.empID = localStorage.getItem("ParEmployeeID");
    this.emp_id = localStorage.getItem('Employee_Id');
    this.getEmpSummaryDetails();
    this.role = localStorage.getItem("Role")
    if (this.role === "PC Client") {
      this.clientDisable = true;
      this.clientHidden = true;
      this.fxDisplay = 30;
    } else {
      this.clientDisable = false;
      this.clientHidden = false;
      this.fxDisplay = 30;
    }
  }
  getEmpSummaryDetails() {
    let roleVal = parseInt(localStorage.getItem("RoleVal"));
    if (roleVal === 8) {
      this.parEmployeeService.getEmployeeByDbId(this.emp_id).subscribe(res => {
        this.getAllPAREmployeeDataById = res.Employees[0];
      });
    } else {
      this.parEmployeeService.getEmployeeByDbId(this.employeeId).subscribe(res => {
        this.getAllPAREmployeeDataById = res.Employees[0];
      }, err => {
        this.DocListErrMsg = "PAR Employee Updation" + err;
        this.DocListErr = true;
      });
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/components/paremployee-summary-tab/paremployee-summary-tab.component.ts